gsap.registerPlugin(ScrollTrigger, CSSRulePlugin, CSSPlugin);

// Texture loader
const textureLoader = new THREE.TextureLoader()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

const geometry = new THREE.PlaneBufferGeometry(1, 1)


// People.

// Layer 01
const material_1 = new THREE.MeshBasicMaterial({
  map: textureLoader.load(`./assets/images/cover/1920/ouleye.png`),
  transparent: true
})

const img_1 = new THREE.Mesh(geometry, material_1)
img_1.scale.set(711 + (711 * .3), 1042 + (1042 * .3), 0)
img_1.position.set(320, -10, 0)

scene.add(img_1)

// Layer 02
const material_2 = new THREE.MeshBasicMaterial({
  map: textureLoader.load(`./assets/images/cover/1920/moustapha.png`),
  transparent: true
})

const img_2 = new THREE.Mesh(geometry, material_2)
img_2.scale.set(1136 + (1136 * 1.35), 759 + (759 * 1.35), 0)
img_2.position.set(-1200, 100, -600)

scene.add(img_2)

// Layer donna-pozzo
const material_donnaPozzo = new THREE.MeshBasicMaterial({
  map: textureLoader.load(`./assets/images/cover/1920/donna-pozzo.png`),
  transparent: true
})

const donnaPozzo = new THREE.Mesh(geometry, material_donnaPozzo)
donnaPozzo.scale.set(820 + (820 * .9), 1236 + (1236 * .9), 0)
donnaPozzo.position.set(1100, 0, -350)

scene.add(donnaPozzo)


// Backgrounds.

// Layer bg base
const material_base = new THREE.MeshBasicMaterial({
  map: textureLoader.load(`./assets/images/cover/1920/hero-base-level.jpg`),
  transparent: true
})

const img_base = new THREE.Mesh(geometry, material_base)
img_base.scale.set(1920 + (1920 * 1.9), 1236 + (1236 * 1.9), 0)
img_base.position.set(0, 0, -1000)

scene.add(img_base)

// Layer bg medio
const material_dietro_pozzo = new THREE.MeshBasicMaterial({
  map: textureLoader.load(`./assets/images/cover/1920/dietro-pozzo.png`),
  transparent: true
})

const img_dietroPozzo = new THREE.Mesh(geometry, material_dietro_pozzo)
img_dietroPozzo.scale.set(822 + (822 * 1.9), 210 + (210 * 1.9), 0)
img_dietroPozzo.position.set(1400, 0, -600)

scene.add(img_dietroPozzo)

// Layer bg alto
const material_alto = new THREE.MeshBasicMaterial({
  map: textureLoader.load(`./assets/images/cover/1920/livello-alto.png`),
  transparent: true,
  // opacity: .5
})

const img_alto = new THREE.Mesh(geometry, material_alto)
img_alto.scale.set(1380 + (1380 * 0.87), 726 + (726 * 0.87), 0)
img_alto.position.set(-830, -340, -601)

scene.add(img_alto)

/**
* Sizes
**/
let coverContainer = document.querySelector('.cover');
let coverWidth = coverContainer.offsetWidth;
let coverHeight = coverContainer.offsetHeight;
let sizesRatio = coverWidth / coverHeight;

const sizes = {
  width: coverWidth,
  height: coverHeight,
  ratio: sizesRatio
}

window.addEventListener('resize', () => {
  // Update sizes
  sizes.width = coverWidth
  sizes.height = coverHeight
  
  // Update camera
  camera.aspect = sizes.width / sizes.height
  camera.updateProjectionMatrix()
  
  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
* Camera
*/
const camera = new THREE.PerspectiveCamera( 75, sizes.width / sizes.height, 0.1, 10000 );
camera.position.z = 800;
scene.add(camera)


/**
* Renderer
**/
const renderer = new THREE.WebGLRenderer({
  canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

function coverMinHeight() {
  if (sizes.ratio > 1.7) {
    let coverHeight = coverWidth / 1.7778
    sizes.width = coverWidth
    sizes.height = coverHeight
    
    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()
    
    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
  }
}

coverMinHeight();

/**
* Animate
**/

let mouse_posX = 0;
let mouse_posY = 0;
let requestId;

const animate = () => {
    // Update objects
    camera.position.x = mouse_posX * 0.08
    camera.position.y = mouse_posY * 0.05
    // img_1.position.x = mouse_pos * 0.1

    // Render
    renderer.render(scene, camera)

    // Call animate
    requestId = window.requestAnimationFrame(animate)
}

animate();

// start render
function start() {
  animate();
}

// stop render
function stop() {
  window.cancelAnimationFrame(requestId)

  if (window.ThreeSound.player.isPlaying) {
    window.ThreeSound.pause();
  }
  window.ThreeSound.updateControls();
}

const statusElem = document.querySelector('.status');

const onScreen = new Set();
const intersectionObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      onScreen.add(entry.target);
      start();
    } else {
      onScreen.delete(entry.target);
      stop();
    }
  });
});

document.querySelectorAll('.cover').forEach(elem => {
  intersectionObserver.observe(elem);
});

// Detect mouse move on canvas.
document.addEventListener('mousemove', event => {
  mouse_posX = event.pageX - (coverWidth / 2);
  mouse_posY = event.pageY - (coverHeight / 2);
})
/**
* Audio
**/

// create an AudioListener and add it to the camera
const listener = new THREE.AudioListener();
camera.add(listener);

// create a global audio source
const sound = new THREE.Audio(listener);
window.ThreeSound = {
  player: sound,
  status: 0
}
window.ThreeSound.play = function(force) {
  if (force == true) {
    this.status = 1;
  }
  if (this.status == 1) {
    this.player.play();
  }
  this.updateControls();
}
window.ThreeSound.stop = function() {
  this.status = 0;
  this.player.pause();
  this.updateControls();
}
window.ThreeSound.pause = function() {
  this.player.pause();
  this.updateControls();
}
const playButton = document.querySelector('.audio-controller-btn');
window.ThreeSound.updateControls = function() {
  if (this.player.isPlaying) {
    playButton.classList.add('playing');
  } else {
    playButton.classList.remove('playing');
  }
}
playButton.addEventListener('click', function(event) {
  if (window.ThreeSound.player.isPlaying) {
    window.ThreeSound.stop();
  } else {
    window.ThreeSound.play(true);
  }
  window.ThreeSound.updateControls();
});


// load a sound and set it as the Audio object's buffer
const audioLoader = new THREE.AudioLoader();
audioLoader.load( './assets/sounds/sahel-audio.mp3', function( buffer ) {
  sound.setBuffer( buffer );
  sound.setLoop( true );
  sound.setVolume( 0.1 );
  window.ThreeSound.play(false);
});

let cover = document.getElementById("cover");
let coverText = cover.querySelector(".cover-title");
let coverStrongText = coverText.querySelector("strong");
let header = document.getElementById("header");
let logoWFP = header.querySelector(".header-logo");
let langSwitcher = header.querySelector(".header-nav");
let langItem = langSwitcher.querySelectorAll(".header-nav-item");
let audioController = header.querySelector(".audio-controller");

let heroTimeline = gsap.timeline({
  scrollTrigger: {
    trigger: cover
  }
});

coverText.split = new SplitText(coverText, { 
  type: "lines,words,chars",
  linesClass: "split-line"
});

heroTimeline.from(canvas, {opacity: 0, scale: 1.05, duration: 1, delay: 1})
            .from(logoWFP, {opacity: 0, y: -10, ease: "circ.out", duration: 1})
            .from(langItem, {opacity: 0, x: 10, ease: "circ.out", duration: .5, stagger: .25},'-=1')
            .from(audioController, {opacity: 0, x: 10, ease: "circ.out", duration: .5, stagger: .25},'-=.25')
            .from(coverText.split.chars, {opacity: 0, yPercent: 100, duration: .5, ease: "circ.out", stagger: .02},'-=1')
            .from(coverStrongText, {css: {backgroundColor: "transparent", duration: .2}},'-=.25')
